import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: 'https://avanti-erp.com/',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

// Agregamos un interceptor para manejar errores globales
// axiosInstance.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response.status === 401) {
//       // Manejo de errores de autenticación
//       console.error('No autorizado, redirigiendo al login...')
//       // Aquí podrías redirigir al login o mostrar un mensaje de error
//     }
//     return Promise.reject(error)
//   }
// )

export default axiosInstance



// WEBPACK FOOTER //
// ./src/global-services/axiosInstance.js